{
  "title": "Version des composants",
  "technicalVersion": "Version technique :",
  "components": {
    "alertManager": "Gestione avvisi",
    "deviceTwinManagerEsoft": "Gestione apparati gemelli (eSoftLink)",
    "campaignManager": "Gestione campagne",
    "pkiConnector": "Connettore PKI",
    "userManager": "Gestione utenti",
    "applicationManager": "Gestione applicazioni",
    "contentManager": "Gestione contenuti",
    "caCertificateManager": "Gestione autorità di certificazione",
    "certificateManager": "Gestione certificati",
    "apiGateway": "Gateway API",
    "translationManager": "Gestione traduzioni",
    "operationManager": "Gestione operazioni",
    "deviceTwinManager": "Gestione apparati gemelli",
    "licenseManager": "Gestione licenze",
    "dataManager": "Gestione dati",
    "as": "Servizio applicazioni front-end",
    "fi": "Interfaccia front-end",
    "lwm2mConnector": "Connettore LwM2M",
    "dataEnrichment": "Arricchimento dati"
  },
  "tile": {
    "version": "Versione",
    "noData": "La version de ce composant n'a pas pu être récupérée.",
    "component": "Composant"
  }
}
